export const TOOLBAR_CONTROL =
  'hover:text-fg-default transition-ink focus-visible:outline-brand flex h-8 shrink-0 cursor-pointer items-center gap-1.5 rounded-full px-3 text-sm edge focus-visible:outline-2';

export const TOOLBAR_ICON_CONTROL =
  'text-fg-tertiary hover:text-fg-default transition-ink focus-visible:outline-brand flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-full edge focus-visible:outline-2';

export const TOOLBAR_PRIMARY =
  'bg-surface-inverse-bg hover:bg-surface-inverse-hover-bg text-fg-inverse focus-visible:outline-brand flex h-8 shrink-0 cursor-pointer items-center gap-1.5 rounded-full px-3 text-sm font-medium focus-visible:outline-2 focus-visible:outline-offset-2';

export const TOOLBAR_GROUP =
  'flex h-8 shrink-0 items-center gap-0.5 rounded-full p-0.5 edge';

export const TOOLBAR_GROUP_OPTION =
  'transition-ink focus-visible:outline-brand flex h-7 cursor-pointer items-center rounded-full px-3 text-sm focus-visible:outline-2';
